// -- other --
import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
import Table from "../../../../../core/dataTable/non-pager/index";
import {Toaster} from 'react-hot-toast';
import Order_Payment_Edit_Modal from "./orderPaymentEditModal";
import {UrlQuery} from "biz9-react-utility";
// -- biz9 --
import {Log,DateTime,Str} from "biz9-utility";
import FormNoData from '../../../../formNoData';
import {User_Table} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {Field,Message,Title,Type,Url} from "../../../../../constant";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Remote_Store_Order} from "biz9-portal-app";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../../project";
/*
 * -- DEFINE -- *
 * --- BUTTONZ ---
 * btn_post_status -- edit status type.
 * btn_post_order_payment -- add payment modal.
*/

const Dashboard_User_Order_Detail = () => {
    const query = UrlQuery();
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.ORDER));
    const [val_order_number,setValOrderNumber] = useState(query.get('order_number'));
    const [val_status_type,setValUserStatusType] = useState('');
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
    const [order,setOrder] = useState(Data_Logic.get(Portal_Table.ORDER,0));
    const [order_items,setOrderItems] = useState([]);
    const [order_payments,setOrderPayments] = useState([]);
    const [order_sub_items,setOrderSubItems] = useState([]);
    const order_item_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.title}
                   </>
                   )
    },
    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               )
    },
   ];
    const order_payment_columns = [
    {
title: "Payment Amount",
           dataIndex: "payment_amount",
           key: "payment_amount",
           render: (text: string, record: any) => (
                   <>
                   {Str.get_money(record.payment_amount)}
                   </>
                   )
    },

    {
title: "Payment Method Type",
       dataIndex: "payment_method_type",
       key: "payment_method_type",
       render: (text: string, record: any) => (
               <>
               {record.payment_method_type}
               </>
               )
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        )
    },

    {
title: "Transaction ID",
       dataIndex: "transaction_id",
       key: "transaction_id",
       render: (text: string, record: any) => (
               <>
               {record.transaction_id}
               </>
               )
    },
    ];
  const order_sub_item_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.title}
                   </>
                   )
    },
    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               )
    },
   ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(!Str.check_is_null(val_order_number)){
            get_data();
            }
            },[val_order_number]);
    async function get_data() {
        const [response,data] = await Portal_Remote_Store_Order.get(App.get_url(Portal_Url.STORE_ORDER_GET),val_order_number);
        Log.w('111_response',response);
        Log.w('111_data',data);
        Log.w('111_data_parent',data.parent);
        Toast_Message.dismiss();
        bind_items(data);
    }
    async function bind_items(data){
        setOrder(data);
        setUser(data.user);
        setOrderItems(data.order_items);
        setOrderPayments(data.order_payments);
        setValUserStatusType(data[Portal_Type.ORDER_STATUS_TYPE]);
        let order_item_sub_items = [];
        data.order_items.forEach(order_item => {
            order_item_sub_items = order_item_sub_items.concat(order_item.order_sub_items);
        });
        setOrderSubItems(order_item_sub_items);
    }
    async function btn_post_status_type(){
    };
    async function btn_post_order_payment(){
    };

    const updateOrderPayment = (order_payment) => {
        setOrderPayments([...order_payments, order_payment]);
    };
    const updateUserAppStatusType = (order) => {
        setValUserStatusType(order.user_status_type)
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content">
            <div className="row justify-content-center">
            <div className="col-xl-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
<ul className="nav nav-tabs nav-tabs-bottom mb-4">
<li className="nav-item">
<Link to={all_routes.dashboard_user_order} className="nav-link" >
{"<- Back"}
</Link>
</li>
</ul>
            <div className="card profile-card">

            {/* CARD CONTENT-START */}
            <div className="card-body">
            <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
            <div className="d-flex align-items-center flex-shrink-0">
            <div className="ms-3">
            <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
            {App.get_app_status_type_by_type(val_status_type).label}
            </h6>
                </div>
                </div>
                <Link to={"#"} hidden={true} onClick={() => btn_post_status_type()}  className="btn btn-lg btn-dark"  data-bs-toggle="modal" data-bs-target="#app_status_type_edit_modal" >
               {Title.LABEL_STATUS}
                </Link>
                </div>
                </div>
                </div>
                {/* CARD CONTENT-END */}

             {/* CARD CONTENT-PROFILE-START */}
                <div className="card profile-details">
                <div className="card-header">
                <h5 className="mb-0">{Title.LABEL_ORDER_DETAILS}</h5>
                </div>
                <div className="card-body">
                <div className="row row-gap-3">
                <div className="col-md-4 col-sm-6">
                <h6>{Title.LABEL_ORDER_NUMBER}</h6>
                <p className="mb-0">{order.order_number}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>{Title.LABEL_ORDER_NUMBER}</h6>
                <p className="mb-0">{DateTime.get_date(order.date_create)}{" "}{DateTime.get_time(order.date_create)}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>{Title.LABEL_GRAND_TOTAL}</h6>
                <p className="mb-0">{Str.get_money(order.grand_total)}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>{Title.LABEL_PAYMENT_PLAN}</h6>
                <p className="mb-0">{order[Portal_Type.ORDER_PAYMENT_PLAN_TYPE]}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Blank</h6>
                <p className="mb-0">{'blank'}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Blank</h6>
                <p className="mb-0">blank</p>
                </div>
                </div>
                </div>
                </div>
                {/* CARD CONTENT-PROFILE-END */}

                <div className="card profile-details">
                 <div className="card-header">
                        <h5 style={{float:'left'}} className="mb-0">{Title.LABEL_ORDER_PAYMENTS}</h5>
                            <Link hidden={true} id={"btn_post_order_payment"}  style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_payment_edit_modal" className="btn btn-lg btn-dark mb-0">
                            {Title.LABEL_ADD}
                            </Link>
               </div>
                <div className="table-responsive custom-table">
                <Table allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_payments} columns={order_payment_columns} Selection={false} />
                </div>
                </div>
                <div className="card profile-details">
                <div className="card-header">
                <h5 className="mb-0">{Title.LABEL_ORDER_ITEMS}</h5>
                </div>
                <div className="table-responsive custom-table" >
                <Table allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_items} columns={order_item_columns} Selection={false} />
                </div>
                </div>
                <div className="card profile-details">
                <div className="card-header">
                <h5 className="mb-0">{Title.LABEL_ORDER_SUB_ITEMS}</h5>
                </div>
                <div className="table-responsive custom-table">
                <Table  allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_sub_items} columns={order_item_columns} Selection={false} />
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
                <Order_Payment_Edit_Modal order={order} onUpdate={updateOrderPayment} />
            </>
                );
};

export default Dashboard_User_Order_Detail;
